module.exports = __webpack_public_path__ + "media/images/features/support/heading-type-tel-06691985bdde2ba3eb69fe57afdeaa5d.svg";